import { Box, Text, TextButton } from "@wix/design-system";
import { useTranslation } from "@wix/fe-essentials-standalone";
import { DesignTokenSmall } from "@wix/wix-ui-icons-common";
import { BUDGET_EXCEEDED_LEARN_MORE_URL } from "../../../consts";

export const BudgetExceeded = () => {
  const { t } = useTranslation();

  return (
    <Box
      direction="vertical"
      align="left"
      verticalAlign="middle"
      alignSelf="flex-start"
      padding="24px 12px 8px 12px"
    >
      <Box gap="4px" verticalAlign="middle">
        <DesignTokenSmall />
        <Text size="small" weight="bold">
          {t("landing.budgetExceeded.title")}
        </Text>
      </Box>
      <Box gap="4px" verticalAlign="middle">
        <Text size="small" secondary>
          {t("landing.budgetExceeded.description")}
        </Text>
        <TextButton
          size="small"
          as="a"
          href={BUDGET_EXCEEDED_LEARN_MORE_URL}
          target="_blank"
        >
          {t("landing.budgetExceeded.learnMore")}
        </TextButton>
      </Box>
    </Box>
  );
};
